/**
 * Lookup values for Use of Force module
 * 
 * These values represent the unique values that can be used when generating mock data.
 */

/**
 * Unique values for ReasonForUseOfForce
 */
export const REASON_FOR_USE_OF_FORCE_VALUES: readonly string[] = [
  'Actual Assaulting Civilian',
  'Actual Assaulting Officer',
  'Damaging property',
  'Effect Arrest',
  'Fleeing',
  'Other',
  'Overcome Resistance',
  'Prevent Commission of Offense',
  'Prevent Escape',
  'Protect Public',
  'Protect Self',
  'Resisting',
  'Self-inflicted injury',
  'Threat of Assault Civilian',
  'Threat of Assault Officer',
] as const;

/**
 * Unique values for TypeOfIncident
 */
export const TYPE_OF_INCIDENT_VALUES: readonly string[] = [
  '72 Hour (Not Suicidal)',
  'Alarm',
  'Alcohol Influence',
  'Arrest Situation',
  'Arrested',
  'Assault',
  'Assist Another LE Agency',
  'B&E/Burglary',
  'Barricade',
  'Burglary',
  'Call for Service',
  'Civil Disobedience',
  'Closing Hours',
  'Code Blue - Jail ',
  'Controlled Substance Possession',
  'Court Order Violation',
  'Crime In Progress',
  'Criminal Damage to Property (Domestic Related)',
  'Criminal Trespass',
  'Crisis Intervention',
  'DUI',
  'Disorderly Conduct',
  'Disturbance',
  'Disturbance/Fight ',
  'Domestic',
  'Domestic Dispute',
  'Domestic Disturbance',
  'Domestic Related Offense',
  'Domestic Violence',
  'Domestic Violence / Family Disturbance',
  'EDP',
  'Economic Crime',
  'Family Fight',
  'Fare Evasion',
  'Field Interview',
  'Felony Stop',
  'Fight',
  'Foot Pursuit',
  'Fraud/Forgery/ID Theft',
  'Georgia Mental Health Act',
  'Gun',
  'Harassment/Threat',
  'Intoxicated Person',
  'Intoxication',
  'Liquor Violation',
  'Loud Party/Noise',
  'Mental Health',
  'Minor Consumption / Open Container',
  'Miscellaneous / Other Not Listed',
  'Motor Vehicle Theft',
  'Motor vehicle stop',
  'OVI',
  'Obstruction of LE',
  'Occupied Vehicle Check',
  'Officer Initiated',
  'Other',
  'Outside LE Agency Assist',
  'Persons Crime',
  'Pornography ',
  'Property Crime',
  'Public Intoxication',
  'Public Order Crime',
  'Pursuit-Foot',
  'Pursuit-Vehicle',
  'Radio Call',
  'Resisting Arrest',
  'Robbery',
  'Search Warrant',
  'Shoplift',
  'Show of  Lethal Weapon',
  'Stab/Gunshot',
  'Stolen Vehicle',
  'Stop-Stick Report',
  'Suicidal',
  'Suicidal Person',
  'Suspicious Person',
  'Suspicious Person / Circumstance',
  'Suspicious Person/Activity',
  'Theft',
  'Theft/PSP/Property',
  'Traffic Offense',
  'Traffic Related',
  'Traffic Stop',
  'Trespass',
  'Trespass/Prowler',
  'Unwanted Subject',
  'Vehicle Prowl/Theft',
  'Wanted Person Located',
  'Warrant',
  'Warrant Operation',
  'Warrant Service',
  'Weapons Offense',
  'Weapons Violation',
  'Welfare Check / ITA',
] as const;
